import React from 'react';
import Modal from '../Modal/Modal';
import styles from './ConfirmationDialog.module.css';

/**
 * Confirmation dialog component for actions that need user confirmation
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the dialog is open
 * @param {Function} props.onConfirm - Function to call when user confirms
 * @param {Function} props.onCancel - Function to call when user cancels
 * @param {string} props.title - Title of the dialog
 * @param {string} props.message - Message to display in the dialog
 * @param {string} props.confirmText - Text for the confirm button (default: "OK")
 * @param {string} props.cancelText - Text for the cancel button (default: "Cancel")
 */
const ConfirmationDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  message,
  confirmText = "OK",
  cancelText = "Cancel"
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title={title}
      className={styles.confirmationDialog}
      closeOnBackdropClick={false}
    >
      <div className={styles.confirmationContent}>
        <p className={styles.confirmationMessage}>{message}</p>
        <div className={styles.buttonContainer}>
          <button
            type="button"
            className={`${styles.button} ${styles.cancelButton}`}
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button
            type="button"
            className={`${styles.button} ${styles.confirmButton}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationDialog;